module.exports = __webpack_public_path__ + "static/media/cursosdev.429453a2.png";